export { DisplayGrid, type DisplayGridProps } from './DisplayGrid';
